import { render, staticRenderFns } from "./userUploadDetails.vue?vue&type=template&id=ac498ff4&scoped=true"
import script from "./userUploadDetails.vue?vue&type=script&lang=js"
export * from "./userUploadDetails.vue?vue&type=script&lang=js"
import style0 from "./userUploadDetails.vue?vue&type=style&index=0&id=ac498ff4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac498ff4",
  null
  
)

export default component.exports